export default __webpack_public_path__ + "static/media/couple.14bd535d.jpeg";